import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Chatroom from './Chatroom/Chatroom.js'
import ChatroomList from './ChatroomList.js'
import ChatroomUsers from './ChatroomUsers.js'
import ChatroomHeader from './ChatroomHeader.js'

class Chatrooms extends React.Component {
  state = {
    message: "",
    loading: false,
    selectedChatroom: this.props.chatrooms[0],
    selectedChatroomUsers: [],
    chatrooms: this.props.chatrooms,
    userOptions: [],
    locationOptions: [],
    positionOptions: [],
    locationId: null,
    positionId: null,
    unreadChatrooms: [],
    chatroomTypeFilter: "",
    activeChatroomFilter: 1
  };

  async componentDidMount() {
    const [
      employeeResponse,
      locationResponse,
      positionResponse,
      chatroomUsersResponse,
      unreadChatroomsResponse
    ] = await Promise.all([
      axios.get("/api/v1/employees.json?digichat=true"),
      axios.get("/locations.json?active=true"),
      axios.get("/positions.json?active=true"),
      this.state.selectedChatroom ? axios.get(`/chatrooms/${this.state.selectedChatroom.id}/chatrooms_users`) : {},
      axios.get(`/chatrooms/unread_chatrooms`)
    ]);

    this.setState({
      userOptions: employeeResponse.data,
      locationOptions: locationResponse.data,
      locationId: locationResponse.data[0].id,
      positionOptions: positionResponse.data,
      positionId: positionResponse.data[0].id,
      selectedChatroomUsers: chatroomUsersResponse.data || [],
      unreadChatrooms: this.unreadChatroomsExcept(this.props.chatrooms[0], unreadChatroomsResponse.data)
    });
  }

  render() {
    const {
      currentUser,
      chatroomTypes
    } = this.props;

    const {
      chatrooms,
      selectedChatroom,
      unreadChatrooms,
      selectedChatroomUsers,
      userOptions,
      locationOptions,
      positionOptions,
      locationId,
      positionId,
      chatroomTypeFilter,
      activeChatroomFilter
    } = this.state;

    return (
      <div>
      <h1>DigiChat</h1>
        <ChatroomHeader
          currentUser={currentUser}
          chatroomTypes={chatroomTypes}
          addChatroom={this.addChatroom}
          userOptions={userOptions}
          locationOptions={locationOptions}
          positionOptions={positionOptions}
          locationId={locationId}
          positionId={positionId}
          chatroomTypes={chatroomTypes}
          chatroomTypeFilter={chatroomTypeFilter}
          activeChatroomFilter={activeChatroomFilter}
          changeChatroomTypeFilter={this.changeChatroomTypeFilter}
          changeActiveChatroomFilter={this.changeActiveChatroomFilter}
        />
        <div className="row">
          <div className="col-md-3">
            <ChatroomList
              chatrooms={chatrooms}
              selectedChatroom={selectedChatroom}
              selectChatroom={this.selectChatroom}
              unreadChatrooms={unreadChatrooms}
            />
          </div>
          <div className="col-md-6">
            <div className="well shadowDepth1">
              { selectedChatroom ? (
                <Chatroom
                  currentUser={currentUser}
                  chatroom={selectedChatroom}
                  selectedChatroomUsers={selectedChatroomUsers}
                  users={selectedChatroom.chatrooms_users}
                  userOptions={userOptions}
                  locationOptions={locationOptions}
                  positionOptions={positionOptions}
                  locationId={locationId}
                  positionId={positionId}
                  removeChatroom={this.removeChatroom}
                  updateChatroom={this.updateChatroom}
                />
              ) : (
                <p className="pink-text">{this.noChatroomsMessage()}</p>
              )}
            </div>
          </div>
          <div className="col-md-3">
            { selectedChatroom &&
              <ChatroomUsers
                selectedChatroomUsers={selectedChatroomUsers}
              />
            }
          </div>
        </div>
      </div>
    );
  }

  noChatroomsMessage = () => {
    var activeOrArchivedChat = "active";

    if (this.state.activeChatroomFilter == 0) {
      activeOrArchivedChat = "archived";
    }

    switch(parseInt(this.state.chatroomTypeFilter)) {
      case 0:
        return `There are currently no ${activeOrArchivedChat} employee chats.`;
      case 1:
        return `There are currently no ${activeOrArchivedChat} location chats.`;
      case 2:
        return `There are currently no ${activeOrArchivedChat} position chats.`;
      default:
        return `There are currently no ${activeOrArchivedChat} chats.`;
    }
  };

  unreadChatroomsExcept = (chatroom, unreadChatrooms) => {
    if (unreadChatrooms) {
      return unreadChatrooms.filter(
        (chatroomId) => chatroomId != chatroom.id
      );
    } else {
      return this.state.unreadChatrooms.filter(
        (chatroomId) => chatroomId != chatroom.id
      );
    }
  };

  selectChatroom = (chatroom) => {
    axios.get(`/chatrooms/${chatroom.id}/chatrooms_users`).then((resp) => {
      this.setState({
        selectedChatroomUsers: resp.data,
        selectedChatroom: chatroom,
        unreadChatrooms: this.unreadChatroomsExcept(chatroom)
      });
    });
  };

  changeChatroomTypeFilter = (newFilter) => {
    const chatroomsUrl = `/chatrooms.json?chatroom_type=${newFilter}&active=${this.state.activeChatroomFilter}`;

    axios.get(chatroomsUrl).then((resp) => {
      this.setState({
        chatroomTypeFilter: newFilter,
        chatrooms: resp.data
      });
      this.selectChatroom(resp.data[0]);
    });
  };

  changeActiveChatroomFilter = (newFilter) => {
    const chatroomsUrl = `/chatrooms.json?active=${newFilter}&chatroom_type=${this.state.chatroomTypeFilter}`;

    axios.get(chatroomsUrl).then((resp) => {
      this.setState({
        activeChatroomFilter: newFilter,
        chatrooms: resp.data
      });
      this.selectChatroom(resp.data[0]);
    });
  };

  stateChatroomsExcept = (chatroomToRemove) => {
    return this.state.chatrooms.filter(function(chatroom) {
      return chatroom.id !== chatroomToRemove.id
    });
  }

  removeChatroom = (chatroomForDeletion) => {
    const chatrooms = this.stateChatroomsExcept(chatroomForDeletion);

    if (chatrooms.length) {
      this.setState({ chatrooms: chatrooms });
      this.selectChatroom(chatrooms[0]);
    } else {
      this.setState({
        chatrooms: chatrooms,
        selectedChatroom: null,
        selectedChatroomUsers: []
      });
    };
  };

  addChatroom = (chatroom) => {
    var chatrooms = this.state.chatrooms;
    chatrooms.unshift(chatroom);
    this.setState({ chatrooms: chatrooms });
    this.selectChatroom(chatroom);
  };

  updateChatroom = (chatroomUpdated) => {
    var chatrooms = this.stateChatroomsExcept(chatroomUpdated);
    chatrooms.unshift(chatroomUpdated);
    this.setState({ chatrooms: chatrooms });
    this.selectChatroom(chatroomUpdated);
  }
}

Chatrooms.propTypes = {
  chatrooms: PropTypes.array,
  currentUser: PropTypes.object,
  chatroomTypes: PropTypes.array
};

export default Chatrooms;
